import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function renderMarkdown(text) {
  if (!text) return '';
  return text
    .replace(/^### (.+)$/gm, '<h3 class="text-lg font-bold text-white font-[Chivo] mt-8 mb-3">$1</h3>')
    .replace(/^## (.+)$/gm, '<h2 class="text-2xl md:text-3xl font-black text-white font-[Chivo] mt-10 mb-4">$1</h2>')
    .replace(/\*\*(.+?)\*\*/g, '<strong class="text-white font-semibold">$1</strong>')
    .replace(/^- (.+)$/gm, '<li class="text-zinc-400 text-sm leading-relaxed ml-4 list-disc">$1</li>')
    .replace(/\n\n/g, '<br/><br/>')
    .replace(/\n/g, '<br/>');
}

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(`${API}/pages/${slug}`);
        setPage(res.data);
      } catch (err) {
        console.error('Failed to fetch page:', err);
      }
      setLoading(false);
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen pt-28 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#ED2227] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen pt-28 flex items-center justify-center">
        <p className="text-zinc-500">Page not found</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-28 md:pt-32 pb-24" data-testid={`legal-page-${slug}`}>
      <div className="max-w-[800px] mx-auto px-6 md:px-12">
        <div className="mb-12">
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-[#ED2227] block mb-3">
            Partners4Cars
          </span>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight uppercase text-white font-[Chivo]">
            {page.title}
          </h1>
        </div>

        <div
          className="prose prose-invert max-w-none text-zinc-400 text-sm leading-relaxed"
          dangerouslySetInnerHTML={{ __html: renderMarkdown(page.content) }}
          data-testid="legal-page-content"
        />
      </div>
    </div>
  );
}
